export default __webpack_public_path__ + "static/media/plodeIconSvg.019cf030.svg";